<template>
    <div name="input-contract" class="input-contract" ref="scroll">      
        <terms 
            v-if="isTerms"
            @onClose="closeTerms"
        />
        <close-button 
            @close="closeInputContract"
        />
        <img src="../../../assets/contract_step_1.png" class="step" />
        <span class="title">위임장 작성에 필요한 정보를<br>기입해 주세요</span>
        <div class="input-area">
            <text-label 
                :text="'위임장 작성자 선택'"
                :isDefault="true"
            />
            <custom-select-box 
                :options="['만19세 이상: 환자 본인 ', '만19세 미만: 보호자(법정대리인/가족)']"
                :selectedIndex="delegateWithAddition.writer_type"
                :placeHolder="'선택'"
                :title="'위임장 작성 대상 선택'"
                @select="selectType"
                ref="customtype"
            />

            <div v-if="delegateWithAddition.writer_type == 1">
                <text-label 
                    :text="'보호자 성명'"
                    :isDefault="true"
                />
                <input v-model="delegateWithAddition.writer_name" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8)"
                    ref="name"
                    class="input-big"
                    placeholder="이름을 적어주세요"
                />
                <div class="error-info-text">{{ nameError }}</div>
                <text-label 
                    :text="'보호자 생년월일'"
                    :isDefault="true"
                />
                <input v-model="delegateWithAddition.writer_birth" inputmode="numeric" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8)"
                    ref="birth"
                    class="input-big"
                    placeholder="숫자만 적어주세요 (예 19990101)"
                />
                <div class="error-info-text">{{ birthError }}</div>
                <text-label 
                    :text="'환자와의 관계'"
                    :isDefault="true"
                />
                <custom-select-box 
                    :options="['아버지', '어머니', '', '', '', '기타']"
                    :selectedIndex="delegateWithAddition.writer_relationship"
                    :placeHolder="'환자와의 관계 선택'"
                    :title="'환자와의 관계'"
                    @select="selectRelation"
                    ref="relation"
                    id="relation"
                />
                <div class="error-info-text">{{ relationError }}</div>
                <input v-model="delegateWithAddition.writer_relationship_description" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8); margin-top: 8px"
                    ref="etc"
                    class="input-big"
                    placeholder="관계-기타가 무엇인지 입력해 주세요"
                    v-if="delegateWithAddition.writer_relationship === 5"
                    
                />
                <div class="error-info-text">{{ etcError }}</div>
                <text-label 
                    :text="'보호자 휴대폰번호'"
                    :isDefault="true"
                />
                <input v-model="delegateWithAddition.writer_phone_number"  inputmode="numeric" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8); margin-bottom: 8px;"
                    ref="phone"
                    class="input-big"
                    placeholder="숫자만 적어주세요"
                />
                <span class="info-color-text">위임사항 및 요양비 내역을 <span style="color: var(--Gray-50, #A3AAB6);">보내드려요.</span></span>
                <div class="error-info-text">{{ phoneError }}</div>
            </div>

            <text-label 
                :text="'위임내역'"
                :isDefault="true"
            />
            <span class="sub-text">위임 기간 <span v-if="draftProfile.diabetes_type === 'TYPE1'" style="font-weight: 600;">(최대 5년)</span> <span v-else-if="draftProfile.diabetes_type === 'SELF_CATHETER'" style="font-weight: 600;">(최대 5년)</span><span v-else style="font-weight: 600;">(최대 1년)</span></span>
            <div class="select-button-area" v-if="draftProfile.diabetes_type === 'TYPE1'">
                <div class="select-button-active" v-if="selectedRange === 1">
                    5년 위임
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(1)">
                    5년 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;;" class="select-button-active" v-if="selectedRange === 2">
                    3년 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;" class="select-button-inactive" v-else @click="selectRange(2)">
                    3년 위임
                </div>
                <div class="select-button-active" v-if="selectedRange === 3" >
                    직접 선택
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(3)">
                    직접 선택
                </div>
            </div>
            <div class="select-button-area" v-else-if="draftProfile.diabetes_type === 'SELF_CATHETER'">
                <div class="select-button-active" v-if="selectedRange === 1">
                    5년 위임
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(1)">
                    5년 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;;" class="select-button-active" v-if="selectedRange === 2">
                    3년 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;" class="select-button-inactive" v-else @click="selectRange(2)">
                    3년 위임
                </div>
                <div class="select-button-active" v-if="selectedRange === 3" >
                    직접 선택
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(3)">
                    직접 선택
                </div>
            </div>
            <div class="select-button-area" v-else>
                <div class="select-button-active" v-if="selectedRange === 4">
                    1년 위임
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(4)">
                    1년 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;;" class="select-button-active" v-if="selectedRange === 5">
                    6개월 위임
                </div>
                <div style="margin-left: 16px;margin-right: 16px;" class="select-button-inactive" v-else @click="selectRange(5)">
                    6개월 위임
                </div>
                <div class="select-button-active" v-if="selectedRange === 3" >
                    직접 선택
                </div>
                <div class="select-button-inactive" v-else @click="selectRange(3)">
                    직접 선택
                </div>
            </div>
            <div class="range" v-if="selectedRange !== 3">
                <span>{{ `${delegateWithAddition.started_at.substring(0, 4)}년 ${delegateWithAddition.started_at.substring(5, 7)}월 ${delegateWithAddition.started_at.substring(8, 10)}일` }} &nbsp;~&nbsp; <span class="range-bold">{{ `${delegateWithAddition.expired_at.substring(0, 4)}년 ${delegateWithAddition.expired_at.substring(5, 7)}월 ${delegateWithAddition.expired_at.substring(8, 10)}일` }}</span></span>
            </div>
            <div class="range-select" v-else>
                <span>{{ `${delegateWithAddition.started_at.substring(0, 4)}년 ${delegateWithAddition.started_at.substring(5, 7)}월 ${delegateWithAddition.started_at.substring(8, 10)}일` }}</span>
                <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                <div
                    class="input-calendar"
                    ref="dateInput"
                    @click="openDatePickerModal"
                >
                    {{ delegateWithAddition.expired_at ? `${delegateWithAddition.expired_at.substring(0, 4)}년 ${delegateWithAddition.expired_at.substring(5, 7)}월 ${delegateWithAddition.expired_at.substring(8, 10)}일` : '날짜 선택' }}
                </div>
                <date-picker-modal
                    v-if="showDatePickerModal"
                    :initialDate="delegateWithAddition.expired_at"
                    @onClose="closeDatePickerModal"
                    @onConfirm="confirmDatePickerModal"
                />
            </div>
            <span class="info-text" style="margin-top: 4px;">* 시작일은 오늘 날짜로 자동 지정됩니다.</span>
            <div class="error-info-text">{{ endDateError }}</div>
            <text-label 
                :text="'위임일'"
                :isDefault="false"
            />
            <span class="end-date">{{ `${delegateWithAddition.started_at.substring(0, 4)}년 ${delegateWithAddition.started_at.substring(5, 7)}월 ${delegateWithAddition.started_at.substring(8, 10)}일` }}</span>
            <text-label 
                :text="'위임사항'"
                :isDefault="false"
            />
            <span class="info-color-text" v-if="draftProfile.diabetes_type !=='SELF_CATHETER'">당뇨병 소모성재료, 연속혈당측정용 전극(센서)<span v-if="draftProfile.diabetes_type ==='TYPE1'">,<br/>연속혈당측정기, 인슐린자동주입기</span></span>
            <span class="info-color-text" v-else>자가도뇨 소모성 재료</span>

            <!-- agree area -->
            <div class="agree-area">
                <span class="agree-title">약관에 동의해 주세요<span class="red">*</span></span>
                <div class="all-agree" ref="agree" >
                    <check-box 
                        :checked="allAgree"
                        @onClick="allAgreeFunction"
                    />
                    <span @click="allAgreeFunction" class="all-agree-text">모두 동의합니다.</span>
                </div>
                <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>
                <div class="agree-detail-box" style="margin-top: 20px;">
                    <div class="row">
                        <check-box 
                            :checked="delegateWithAddition.agreement_personal_info"
                            @onClick="() => {delegateWithAddition.agreement_personal_info = !delegateWithAddition.agreement_personal_info}"
                        />
                        <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용 동의</span>
                    </div>

                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(1)" src="../../../assets/detail.png" />
                </div>
                <div class="agree-detail-box" style="margin-top: 16px; margin-bottom: 40px">
                    <div class="row">
                        <check-box 
                            :checked="delegateWithAddition.agreement_personal_identification_info"
                            @onClick="() => {delegateWithAddition.agreement_personal_identification_info = !delegateWithAddition.agreement_personal_identification_info}"
                        />
                        <span class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 고유식별정보 수집 및 이용 동의</span>
                    </div>
                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../../../assets/detail.png" />
                </div>
                
            </div>
            <div style="height: 40px;">

            </div>
            <div class="footer-button-area">
                <div style="text-align: center;">
                    <span class="bottom-text">위임장은 한번 작성 후 <span style="font-weight: 600;">수정이 어렵습니다.</span><br>신중하게 진행해주세요!</span>
                </div>
                <!-- next -->
                <bottom-button 
                    :text="'위임장 서명하기'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="nextStep"
                    style="margin-top: 8px;width: 100%;"
                />
            </div>


        </div>

    </div>
</template>

<script>
import CloseButton from '@/components/atoms/CloseButton';
import TextLabel from '@/components/atoms/TextLabel';
import focusBackground from '@/components/directives/focusBackground';
import CustomSelectBox from '@/components/atoms/SelectBox';
import convert from '@/utilities/convert.js';
import CheckBox from '@/components/atoms/CheckBox';
import Terms from '@/components/organisms/contract/Terms';
import Validation from '@/utilities/validation';
import BottomButton from '@/components/atoms/BottomButton';
import DatePickerModal from '@/components/modals/DatePickerModal';

import Constant from '@/constant';

import {mapState} from 'vuex';

export default {
    name: 'inputContract',
    computed: mapState(['status', 'draftProfile', 'delegateWithAddition']),
    data: function()
    {
        return {
            agreeError: false,
            isTerms: false,
            endDateError: '',
            nameError: '',
            birthError: '',
            relationError: '',
            etcError: '',
            phoneError: '',
            selectedRange: 1,
            allAgree: false,
            showDatePickerModal: false
        }
    },
    components: {
        CloseButton,
        TextLabel,
        CustomSelectBox,
        CheckBox,
        Terms,
        BottomButton,
        DatePickerModal
    },
    directives: {
        focusBackground
    },
    created: function()
    {
        if(this.isAdultCheck(this.draftProfile.registration_number))
        {
            this.delegateWithAddition.writer_type = 0;
        }
        else
        {
            this.delegateWithAddition.writer_type = 1;
        }

    },
    mounted: function()
    {

        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        if(this.delegateWithAddition.started_at === '')
        {
            let cur = new Date();
            this.delegateWithAddition.started_at = `${cur.getFullYear()}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
        
            cur.setDate(cur.getDate() - 1);
            this.delegateWithAddition.expired_at = `${cur.getFullYear() + 5}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
        
            if(this.draftProfile.diabetes_type !== 'TYPE1' && this.draftProfile.diabetes_type !== 'SELF_CATHETER')
            {           
                this.selectRange(4)
            }
        }

        this.scrollToTop();
    },
    methods: {
        isAdultCheck: function(residentNumber) {
            const birthYear = parseInt(residentNumber.substring(0, 2), 10);
            const birthMonth = parseInt(residentNumber.substring(2, 4), 10);
            const birthDay = parseInt(residentNumber.substring(4, 6), 10);
            const firstDigit = parseInt(residentNumber.charAt(6), 10);
            console.log(`${birthYear} ${birthMonth} ${birthDay} ${firstDigit}`)
            // 출생 연도 계산 (주민등록번호 뒷자리 첫 숫자에 따라 1900년대, 2000년대 구분)
            let fullBirthYear;
            if (firstDigit === 1 || firstDigit === 2 || firstDigit === 5 || firstDigit === 6) {
                fullBirthYear = 1900 + birthYear;
            } else if (firstDigit === 3 || firstDigit === 4 || firstDigit === 7 || firstDigit === 8) {
                fullBirthYear = 2000 + birthYear;
            } else {
                throw new Error("Invalid resident number first digit.");
            }

            // 현재 날짜 가져오기
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth() + 1; // 월은 0부터 시작
            const currentDay = today.getDate();

            // 만 나이 계산
            let age = currentYear - fullBirthYear;
            if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
                age--; // 생일이 지나지 않았다면 한 살 빼기
            }

            return age >= 19;
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        scrollToTop() {
            // 스크롤 요소를 맨 위로 이동
            this.$refs.scroll.scrollTo({
                top: 0,
                behavior: 'smooth' // 부드러운 스크롤
            });
        },
        scrollToBottom() {
            // 스크롤 요소를 맨 위로 이동
            this.$refs.scroll.scrollTop = this.$refs.scroll.scrollHeight;
        },
        closeInputContract: function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('closeContract')
        },
        selectRange: function(select)
        {
            this.endDateError = '';
            if(select === 1)
            {
                let cur = new Date();
                cur.setDate(cur.getDate() - 1);
                this.delegateWithAddition.expired_at = `${cur.getFullYear() + 5}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }
            else if(select === 2)
            {
                let cur = new Date();
                cur.setDate(cur.getDate() - 1);
                this.delegateWithAddition.expired_at = `${cur.getFullYear() + 3}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }
            else if(select === 4)
            {
                let cur = new Date();
                cur.setDate(cur.getDate() - 1);
                this.delegateWithAddition.expired_at = `${cur.getFullYear() + 1}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }
            else if(select === 5)
            {
                let cur = new Date();
                cur.setMonth(cur.getMonth() + 6);
                cur.setDate(cur.getDate() - 1);
                this.delegateWithAddition.expired_at = `${cur.getFullYear()}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }

            this.selectedRange = select;
        },
        openDatePicker() {
            // 숨겨진 input[type="date"]을 클릭하여 시스템 달력 표시
            this.$refs.dateInput.click();
        },
        openDatePickerModal: function()
        {
            this.showDatePickerModal = true;
        },
        closeDatePickerModal: function()
        {
            this.showDatePickerModal = false;
        },
        confirmDatePickerModal: function(date)
        {
            this.delegateWithAddition.expired_at = date;
            this.showDatePickerModal = false;
        },
        allAgreeFunction: function()
        {
            this.allAgree = !this.allAgree;
        },
        openPolicy: function(index)
        {   
            this.openTerms();
        },
        openTerms: function()
        {
            this.isTerms = true;
        },
        closeTerms: function()
        {
            document.body.style.overflow = 'hidden';
            this.isTerms = false;
        },
        isValidYYYYMMDD: function (dateStr) {
            // 날짜 형식이 YYYYMMDD인지 확인
            if (!/^\d{8}$/.test(dateStr)) {
                return false;
            }

            // 연도, 월, 일 분리
            const year = parseInt(dateStr.substring(0, 4), 10);
            const month = parseInt(dateStr.substring(4, 6), 10);
            const day = parseInt(dateStr.substring(6, 8), 10);

            // 월이 1~12 범위에 있는지 확인
            if (month < 1 || month > 12) {
                return false;
            }

            // JavaScript의 Date 객체로 날짜 유효성 확인
            const date = new Date(year, month - 1, day);

            // Date 객체가 올바른 날짜인지 확인
            return (
                date.getFullYear() === year &&
                date.getMonth() === month - 1 &&
                date.getDate() === day
            );
        },
        nextStep: function()
        {
            if(this.delegateWithAddition.expired_at === null || this.delegateWithAddition.expired_at === "" || this.delegateWithAddition.expired_at === undefined)
            {
                this.errorFocus('dateInput')
                this.endDateError = '위임기간을 선택해주세요.'
                return;
            }

            if(convert.compareDateTime(this.delegateWithAddition.started_at, this.delegateWithAddition.expired_at) !== -1)
            {   
                this.errorFocus('dateInput')
                this.endDateError = '위임기간을 확인해주세요.'
                return;
            }
    
            this.delegateWithAddition.agreement_delegate = true
            
            if(this.delegateWithAddition.writer_type === -1)
            {
                this.errorFocus('customtype')
                return;
            }

            if(this.delegateWithAddition.writer_type === 1)
            {
                if(this.delegateWithAddition.writer_name === '' || this.delegateWithAddition.writer_name === null)
                {
                    this.errorFocus('name')
                    this.nameError = '이름을 입력해 주세요. (한글 또는 영문만 가능)'
                    return;
                }
                if(!Validation.isValidName(this.delegateWithAddition.writer_name))
                {
                    this.errorFocus('name');
                    this.nameError = '이름을 입력해 주세요. (한글 또는 영문만 가능)';
                    return;
                }

                if(this.delegateWithAddition.writer_birth === '' || this.delegateWithAddition.writer_birth === null)
                {
                    this.errorFocus('birth')
                    this.birthError = '생년월일이 올바르지 않습니다. (예 19900101)';
                    return;
                }
                if(!this.isValidYYYYMMDD(this.delegateWithAddition.writer_birth))
                {
                    this.errorFocus('birth')
                    this.birthError = '생년월일이 올바르지 않습니다. (예 19900101)';
                    return;
                }

                if(this.delegateWithAddition.writer_relationship === -1)
                {
                    this.errorFocus('relation')
                    this.relationError = '환자와의 관계를 선택해주세요.';
                    return;
                }
                else if(this.delegateWithAddition.writer_relationship === 5)
                {
                    if(this.delegateWithAddition.writer_relationship_description === '' || this.delegateWithAddition.writer_relationship_description === null)
                    {
                        this.errorFocus('etc')
                        this.etcError = '관계-기타가 무엇인지 입력해 주세요';
                        return;
                    }
                }
                if(!Validation.isValidPhoneNumber(this.delegateWithAddition.writer_phone_number))
                {
                    this.errorFocus('phone')
                    this.phoneError = '보호자 휴대폰번호를 입력해주세요.'
                    return;
                }

            }

            if(this.delegateWithAddition.writer_type == 0)
            {
                // 본인이기 때문에 프로필 정보를 넣는다. 
                this.delegateWithAddition.writer_name = this.draftProfile.name;
                this.delegateWithAddition.writer_birth = this.rrnToBirthYmd(this.draftProfile.registration_number);
                this.delegateWithAddition.writer_phone_number = this.draftProfile.phone_number;
            }

            if(!this.delegateWithAddition.agreement_personal_info || !this.delegateWithAddition.agreement_personal_identification_info)
            {
                this.scrollToBottom();
                this.agreeError = true;
                return;
            }

            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('next', 2);
        },
        normalizeToDateTime00: function (value) {
            if (!value) return null;

            // 1️⃣ 이미 YYYY-MM-DD 00:00:00 형식인지 체크
            const fullPattern = /^\d{4}-\d{2}-\d{2} 00:00:00$/;
            if (typeof value === 'string' && fullPattern.test(value)) {
                return value;
            }

            let date;

            // 2️⃣ Date 객체
            if (value instanceof Date) {
                date = value;
            }
            // 3️⃣ YYYY-MM-DD
            else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                date = new Date(value);
            }
            // 4️⃣ YYYYMMDD
            else if (typeof value === 'string' && /^\d{8}$/.test(value)) {
                const y = value.slice(0, 4);
                const m = value.slice(4, 6);
                const d = value.slice(6, 8);
                date = new Date(`${y}-${m}-${d}`);
            }
            // 5️⃣ 그 외 문자열 (Date 파싱 시도)
            else if (typeof value === 'string') {
                const parsed = new Date(value);
                if (!isNaN(parsed)) {
                date = parsed;
                }
            }

            if (!date || isNaN(date)) return null;

            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd} 00:00:00`;
        },
        selectType: function(selected)
        {
            this.delegateWithAddition.writer_type = selected;
        },
        selectRelation: function(selected)
        {
            this.delegateWithAddition.writer_relationship = selected;
            const element = document.getElementById('relation');
            element.style.border = '0'
            this.relationError = '';
            this.etcError = '';
        },
        errorFocus: function(field)
        {
            if(field !== 'customtype' && field !== 'relation')
            {
                this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';
            }
            else 
            {
                const element = document.getElementById(field);
                element.style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)'
                element.style.borderRadius = '6px'
            }


            const offsetTop = this.$refs[field].offsetTop;

            this.$refs.scroll.scrollTo({
                top: offsetTop - 150,
                behavior: 'smooth' // 부드러운 스크롤
            });

        },
        rrnToBirthYmd: function (rrn) {
            if (typeof rrn !== "string") return null;

            const cleaned = rrn.replace(/\s/g, "");
            const m = cleaned.match(/^(\d{6})-?(\d)(\d{6})$/);
            if (!m) return null;

            const yymmdd = m[1];
            const centuryCode = m[2];

            const yy = yymmdd.slice(0, 2);
            const mm = yymmdd.slice(2, 4);
            const dd = yymmdd.slice(4, 6);

            // 성별/세대 코드 기준(국내): 1,2=1900s / 3,4=2000s / 5,6=1900s(외국인) / 7,8=2000s(외국인)
            let century;
            if (centuryCode === "1" || centuryCode === "2" || centuryCode === "5" || centuryCode === "6") {
                century = "19";
            } else if (centuryCode === "3" || centuryCode === "4" || centuryCode === "7" || centuryCode === "8") {
                century = "20";
            } else {
                return null; // 9,0 등은 구버전/예외 케이스로 처리 필요하면 확장
            }

            return `${century}${yy}${mm}${dd}`;
        },
        compareDates: function (date1, date2) {
            const d1 = new Date(date1);
            const d2 = new Date(date2);

            if (d1 > d2) return 1;     // date1이 더 늦은 날짜
            if (d1 < d2) return -1;    // date1이 더 이른 날짜
            return 0;                  // 두 날짜가 동일
        }
    },  // method
    watch: {
        allAgree: function()
        {
            this.delegateWithAddition.agreement_personal_info = this.allAgree;
            this.delegateWithAddition.agreement_personal_identification_info = this.allAgree;
            this.agreeError = false;

        },
        'delegateWithAddition.writer_phone_number'(newValue) {
            this.delegateWithAddition.writer_phone_number = newValue.replace(/[^0-9]/g, '');
            this.phoneError = '';
        },//this.temp_contract.endDate = `${cur.getFullYear() + 5}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
        'delegateWithAddition.expired_at'(newValue)
        {   
            let cur = new Date();
            cur.setDate(cur.getDate() - 1);
            let maxEndDate = null;
            this.endDateError= '';
            if(this.draftProfile.diabetes_type === 'TYPE1' || this.draftProfile.diabetes_type === 'SELF_CATHETER')
            {
                maxEndDate = `${cur.getFullYear() + 5}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }
            else 
            {
                maxEndDate = `${cur.getFullYear() + 1}-${convert.leadingZeros((cur.getMonth() + 1), 2)}-${convert.leadingZeros(cur.getDate(), 2)}`;
            }
            
            
            if(this.compareDates(maxEndDate, newValue) === -1)
            {
                this.delegateWithAddition.expired_at = maxEndDate;
                this.errorFocus('dateInput')
                if(this.draftProfile.diabetes_type === 'TYPE1' || this.draftProfile.diabetes_type === 'SELF_CATHETER')
                {
                    this.endDateError = '위임기간은 최대 5년까지만 설정할 수 있어요. 선택하신 날짜 대신, 5년째 날짜로 자동 설정됩니다'
                }
                else 
                {
                    this.endDateError = '위임기간은 최대 1년까지만 설정할 수 있어요. 선택하신 날짜 대신, 1년째 날짜로 자동 설정됩니다'
                }      
                
            }
        },
        'delegateWithAddition.writer_name': function()
        {
            this.nameError = '';
        },
        'delegateWithAddition.writer_birth': function()
        {
            this.birthError = '';
        },
        'delegateWithAddition.writer_relationship_description': function()
        {
            this.etcError = '';
        }
    }
}
</script>

<style scoped>
    .input-contract {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px;
        overflow-y: auto;
        height: 100dvh;
    }

    @media (min-width: 600px) {
        .input-contract {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            padding: 15px;
        }
    }

    .step {
        width: 100%;
        max-width: 600px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 30px;
    }

    .input-area {
        width: 100%;
        padding: 30px 0 30px 0;
        box-sizing: border-box;
    }
    .sub-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .select-button-area {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        margin-top: 16px;
    }
    .select-button-inactive {
        width: 31%;
        height: 53px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        cursor: pointer;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .select-button-active {
        width: 31%;
        height: 53px;
        flex-shrink: 0;
        border-radius: 6px;
        background: #184FA1;
        cursor: pointer;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .range {
        height: 62px;
        border-radius: 6px;
        background: var(--Blue-04_Light-blue, #E5F0FC);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-top: 16px;
    }
    .range-select {
        height: 62px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-top: 16px;
    }
    .range-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.36px;
    }
    .input-calendar {
        border: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        letter-spacing: -0.36px;
        cursor: pointer;
        height: 48px;
        padding: 16px 15px;
        box-sizing: border-box;

    }
    @supports (-webkit-touch-callout: none) {
        input[type="date"] {
            height: 48px;
            line-height: 48px;   /* 🔥 핵심 */
            padding: 0 12px;
            box-sizing: border-box;
            font-size: 18px;     /* iOS 줌 방지 + 안정화 */
        }
    }


    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .end-date {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
    }
    .info-color-text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .agree-area {
        padding: 40px 0;
        width: 100%;
        box-sizing: border-box;
    }

    .agree-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .all-agree {
        height: 60px;
        flex-shrink: 0;
        width: calc(100%);
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        margin-top: 30px;
    }
    .all-agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 100% */
        cursor: pointer;
        margin-left: 17px;
    }
    .agree-detail-box {
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100%);
        box-sizing: border-box;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .row {
        display: flex;
    }
    .bottom-text{
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }

    /*  */
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }

    .footer-button-area {
        position: fixed;
        bottom: 0;
        width: 100%;
        background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 255.33%);
        height: 124px;
        z-index: 9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        margin-left: -16px;
    }

    @media (min-width: 600px) {
        .footer-button-area {
            width: 600px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/InputContract.vue